import { render, staticRenderFns } from "./VehicleProvisionCostDetails.vue?vue&type=template&id=387e2559&"
import script from "./VehicleProvisionCostDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionCostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QInput,QIcon,QList,QItemSection,QItemLabel,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QIcon,QList,QItemSection,QItemLabel,QBtn,QTooltip}, component.options.components || {})
